var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accept"},[_c('span',[_vm._v("接收")])])
}]

export { render, staticRenderFns }